import type { Achievement } from "@/app/achievements/page"
import AchievementBadge from "./achievement-page-badge"

interface AchievementsGridProps {
  achievements: Achievement[]
}

export default function AchievementsGrid({ achievements }: AchievementsGridProps) {
  return (
    <section className="mb-10">
      <h2 className="text-2xl font-bold mb-4 text-slate-900">Achievements</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {achievements.map((achievement) => (
          <AchievementBadge key={achievement.id} achievement={achievement} />
        ))}
      </div>
    </section>
  )
}
